/**
 * B2/B4 (brief 2026-10-11-001): the shared date formatter bound to the reader's language
 * (Lao by default, also outside the LanguageProvider — like useRatingLanguage).
 */
import { useCallback } from 'react';
import { useRatingLanguage } from '../utils/ratingLabels';
import { formatAppDate, formatAppRelative, type AppDateStyle } from '../utils/format';

export function useAppDate() {
  const lang = useRatingLanguage();
  const fmt = useCallback(
    (value: string | number | Date | null | undefined, style: AppDateStyle = 'datetime', fallback = '—') =>
      formatAppDate(value, lang, style, fallback),
    [lang],
  );
  const ago = useCallback((value: string | number | Date | null | undefined) => formatAppRelative(value, lang), [lang]);
  return { lang, fmt, ago };
}
